module.exports = __webpack_public_path__ + "static/media/chevron-right.7918f245.svg";